import { ui } from './ui';

/**
 * Picking rows in a table (Stops, Waiting for a route): a click on a row's box ticks it, shift-click takes in every row
 * from the last one picked to this one (all ticked, or all not, as this one goes), ⌘ or Ctrl and a click on a row ticks it
 * without opening it, and ⌘A (Ctrl A) ticks every row shown. What's ticked can then be changed in one go.
 */

/** The row picked last: where a shift-click's range starts. */
let anchor: string | null = null;

/** Ticks or unticks [k] among the rows [shown] (in the order they're shown); with [range], every row from the last one picked. */
export function pick(shown: string[], k: string, range: boolean) {
  ui.set((x) => {
    const sel = new Set(x.sel);
    const on = !sel.has(k);
    const a = range && anchor != null ? shown.indexOf(anchor) : -1;
    const b = shown.indexOf(k);
    const keys = a >= 0 && b >= 0 ? shown.slice(Math.min(a, b), Math.max(a, b) + 1) : [k];
    for (const key of keys) {
      if (on) sel.add(key);
      else sel.delete(key);
    }
    anchor = k;
    return { sel };
  });
}

/** ⌘A: every row shown, ticked. */
export function pickAll(shown: string[]) {
  ui.set((x) => ({ sel: new Set([...x.sel, ...shown]) }));
  anchor = shown.at(-1) ?? null;
}

/** A click on a row: with shift, ⌘ or Ctrl it picks (shift a range); otherwise [open]. */
export function rowClick(e: { shiftKey: boolean; metaKey: boolean; ctrlKey: boolean }, shown: string[], k: string, open: () => void) {
  if (e.shiftKey || e.metaKey || e.ctrlKey) pick(shown, k, e.shiftKey);
  else open();
}

/** Shift-click on a row picks a range; the browser shouldn't select the text under it too. */
export const noTextPick = (e: { shiftKey: boolean; preventDefault: () => void }) => {
  if (e.shiftKey) e.preventDefault();
};
